import { motion } from 'framer-motion';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';

const ProfilePage = () => {
  const careerHistory = [
    {
      year: '1971年',
      title: '京都府京都市生まれ'
    },
    {
      year: '1994年',
      title: '大阪大学経済学部卒業',
      description: '在学中は体育会ワンダーフォーゲル部所属'
    },
    {
      year: '1994年',
      title: '東証1部上場会社印刷会社に入社',
      description: '営業部3年、経理部4年勤務。在籍時日商簿記2級、税理士簿記試験合格'
    },
    {
      year: '2004年',
      title: '公認会計士2次試験合格',
      description: '会社退職後、合格'
    },
    {
      year: '2004年〜',
      title: '監査法人、併設税理士事務所にて勤務',
      description: '上場企業等監査、税務申告業務(法人税、所得税、消費税、相続税、贈与税)、不正等の調査、大量保有報告書の作成等多様な業務に従事'
    },
    {
      year: '2008年6月',
      title: '監査法人解散後、税務申告等の処理を実施'
    },
    {
      year: '2009年7月',
      title: '退職'
    },
    {
      year: '2009年9月',
      title: '赤石会計事務所開業',
      description: '現職'
    },
    {
      year: '2014年4月',
      title: '大阪成蹊大学 非常勤講師',
      description: '担当科目は簿記'
    }
  ];

  return (
    <div className="min-h-screen bg-white">
      <Header />
      <main>
        {/* Hero Section */}
        <section className="pt-32 pb-20 bg-gradient-to-b from-gray-50 to-white">
          <div className="max-w-7xl mx-auto px-6">
            <motion.div
              initial={{ opacity: 0, y: 30 }}
              animate={{ opacity: 1, y: 0 }}
              className="text-center mb-16"
            >
              <div className="inline-block mb-6 px-6 py-2 border border-red/20 bg-red/5 rounded-full">
                <span className="text-red text-sm font-medium">PROFILE</span>
              </div>
              <h1 className="text-5xl md:text-6xl font-bold text-gray-900 mb-6">
                代表プロフィール
              </h1>
              <p className="text-xl text-gray-600">
                勝つ経営を実現する
              </p>
            </motion.div>

            {/* Profile Content */}
            <div className="grid lg:grid-cols-5 gap-12 mb-20">
              {/* Left: Image */}
              <motion.div
                initial={{ opacity: 0, x: -30 }}
                animate={{ opacity: 1, x: 0 }}
                transition={{ delay: 0.2 }}
                className="lg:col-span-2"
              >
                <div className="sticky top-8">
                  <div className="relative rounded-3xl overflow-hidden shadow-2xl">
                    <div className="w-full" style={{ aspectRatio: '800/1000' }}>
                      <img
                        src="https://static.readdy.ai/image/d7a11723d8aa082f15ef10141684e0c1/c3bdfac7e5be97a6aac664b75c2d9360.png"
                        alt="赤石崇士"
                        className="w-full h-full object-cover object-top"
                      />
                    </div>
                  </div>
                  <div className="absolute -bottom-6 -right-6 w-48 h-48 bg-red/10 rounded-full blur-3xl"></div>
                  <div className="absolute -top-6 -left-6 w-48 h-48 bg-red-light/10 rounded-full blur-3xl"></div>
                </div>
              </motion.div>

              {/* Right: Profile Info */}
              <motion.div
                initial={{ opacity: 0, x: 30 }}
                animate={{ opacity: 1, x: 0 }}
                transition={{ delay: 0.3 }}
                className="lg:col-span-3"
              >
                <div className="bg-gradient-to-br from-red/5 to-red-light/5 rounded-3xl p-10 border border-red/10 mb-10">
                  <h2 className="text-4xl font-bold text-red mb-4">
                    赤石 崇士
                  </h2>
                  <p className="text-xl text-gray-700 mb-6">
                    公認会計士・税理士・事業コンストラクター
                  </p>
                  <div className="space-y-4">
                    <div className="flex items-center gap-4">
                      <div className="w-12 h-12 bg-red/10 rounded-full flex items-center justify-center flex-shrink-0">
                        <i className="ri-award-line text-red text-xl"></i>
                      </div>
                      <div>
                        <div className="font-bold text-gray-900">資格</div>
                        <div className="text-gray-600 text-sm">
                          公認会計士・税理士・事業コンストラクター
                        </div>
                      </div>
                    </div>
                    <div className="flex items-center gap-4">
                      <div className="w-12 h-12 bg-red/10 rounded-full flex items-center justify-center flex-shrink-0">
                        <i className="ri-briefcase-line text-red text-xl"></i>
                      </div>
                      <div>
                        <div className="font-bold text-gray-900">事務所</div>
                        <div className="text-gray-600 text-sm">
                          赤石会計事務所 代表
                        </div>
                      </div>
                    </div>
                    <div className="flex items-center gap-4">
                      <div className="w-12 h-12 bg-red/10 rounded-full flex items-center justify-center flex-shrink-0">
                        <i className="ri-map-pin-line text-red text-xl"></i>
                      </div>
                      <div>
                        <div className="font-bold text-gray-900">出身</div>
                        <div className="text-gray-600 text-sm">
                          京都府京都市
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="space-y-6 text-gray-700 leading-relaxed">
                  <p>
                    京都で生まれ育ち、大阪大学経済学部を卒業後、東証1部上場会社の印刷会社に入社しました。
                    営業部と経理部での実務経験を通じて、企業経営の現場を深く理解することができました。
                  </p>
                  <p>
                    在職中に日商簿記2級、税理士簿記試験に合格し、会社退職後に公認会計士2次試験に合格しました。
                    監査法人では上場企業等の監査、税務申告業務、不正調査など多様な業務に従事し、
                    幅広い知識と経験を積むことができました。
                  </p>
                  <p>
                    2009年9月に赤石会計事務所を開業し、現在に至ります。
                    また、2014年からは大阪成蹊大学の非常勤講師として簿記の指導も行っており、
                    次世代の会計人材の育成にも力を注いでいます。
                  </p>
                  <p>
                    「勝つ経営」を実現するために、単なる税務申告代行ではなく、
                    経営者の良きパートナーとして、実践的なアドバイスで事業の成長をサポートすることを使命としています。
                  </p>
                </div>
              </motion.div>
            </div>
          </div>
        </section>

        {/* Career History Section */}
        <section className="py-20 bg-white">
          <div className="max-w-5xl mx-auto px-6">
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              className="text-center mb-16"
            >
              <h2 className="text-4xl font-bold text-gray-900 mb-4">経歴</h2>
              <p className="text-gray-600">
                豊富な実務経験と専門知識で、お客様の経営をサポートします
              </p>
            </motion.div>

            <div className="relative">
              {/* Timeline Line */}
              <div className="absolute left-8 top-0 bottom-0 w-0.5 bg-gradient-to-b from-red via-red-light to-red"></div>

              <div className="space-y-8">
                {careerHistory.map((item, index) => (
                  <motion.div
                    key={index}
                    initial={{ opacity: 0, x: -30 }}
                    whileInView={{ opacity: 1, x: 0 }}
                    viewport={{ once: true }}
                    transition={{ delay: index * 0.1 }}
                    className="relative pl-20"
                  >
                    {/* Timeline Dot */}
                    <div className="absolute left-5 top-2 w-7 h-7 bg-red rounded-full border-4 border-white shadow-lg flex items-center justify-center">
                      <div className="w-2 h-2 bg-white rounded-full"></div>
                    </div>

                    <div className="bg-gradient-to-br from-gray-50 to-white rounded-2xl p-6 border border-gray-100 hover:border-red/20 hover:shadow-lg transition-all">
                      <div className="flex items-baseline gap-4 mb-2">
                        <span className="text-red font-bold text-lg whitespace-nowrap">
                          {item.year}
                        </span>
                        <h3 className="text-xl font-bold text-gray-900">
                          {item.title}
                        </h3>
                      </div>
                      {item.description && (
                        <p className="text-gray-600 leading-relaxed ml-0 mt-2">
                          {item.description}
                        </p>
                      )}
                    </div>
                  </motion.div>
                ))}
              </div>
            </div>
          </div>
        </section>

        {/* Books Section */}
        <section className="py-20 bg-gradient-to-b from-gray-50 to-white">
          <div className="max-w-6xl mx-auto px-6">
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              className="text-center mb-16"
            >
              <h2 className="text-4xl font-bold text-gray-900 mb-4">書籍等</h2>
              <p className="text-gray-600">
                専門知識を活かした書籍の監修・執筆
              </p>
            </motion.div>

            <div className="grid md:grid-cols-2 gap-8">
              {/* Book 1 */}
              <motion.div
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ delay: 0.1 }}
              >
                <div className="bg-white rounded-3xl p-8 shadow-xl border border-gray-100 hover:shadow-2xl transition-all h-full">
                  <div className="flex flex-col gap-6">
                    <div className="w-full max-w-xs mx-auto">
                      <div className="relative rounded-2xl overflow-hidden shadow-lg">
                        <div className="w-full" style={{ aspectRatio: '600/850' }}>
                          <img
                            src="https://static.readdy.ai/image/d7a11723d8aa082f15ef10141684e0c1/d1b58a1f75acc1d2ab9219443e8de418.jpeg"
                            alt="本当の会計の話"
                            className="w-full h-full object-cover object-top"
                          />
                        </div>
                      </div>
                    </div>
                    <div>
                      <div className="inline-block px-4 py-1 bg-red/10 text-red text-sm font-medium rounded-full mb-4">
                        監修
                      </div>
                      <h3 className="text-2xl font-bold text-gray-900 mb-4">
                        本当の会計の話
                      </h3>
                      <div className="space-y-3 text-gray-700">
                        <div className="flex items-start gap-3">
                          <div className="w-6 h-6 bg-red/10 rounded-full flex items-center justify-center flex-shrink-0 mt-0.5">
                            <i className="ri-user-line text-red text-sm"></i>
                          </div>
                          <div>
                            <div className="text-sm text-gray-500 mb-1">著者</div>
                            <div className="font-medium">弥生会計代表取締役 岡本浩一郎</div>
                          </div>
                        </div>
                        <div className="flex items-start gap-3">
                          <div className="w-6 h-6 bg-red/10 rounded-full flex items-center justify-center flex-shrink-0 mt-0.5">
                            <i className="ri-shield-check-line text-red text-sm"></i>
                          </div>
                          <div>
                            <div className="text-sm text-gray-500 mb-1">監修</div>
                            <div className="font-medium">赤石崇士</div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </motion.div>

              {/* Book 2 */}
              <motion.div
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ delay: 0.2 }}
              >
                <div className="bg-white rounded-3xl p-8 shadow-xl border border-gray-100 hover:shadow-2xl transition-all h-full">
                  <div className="flex flex-col gap-6">
                    <div className="w-full max-w-xs mx-auto">
                      <div className="relative rounded-2xl overflow-hidden shadow-lg">
                        <div className="w-full" style={{ aspectRatio: '600/850' }}>
                          <img
                            src="https://static.readdy.ai/image/d7a11723d8aa082f15ef10141684e0c1/309fd9d9f9078c4eae9fc2cf420d5900.jpeg"
                            alt="事業承継機関問題の研究"
                            className="w-full h-full object-cover object-top"
                          />
                        </div>
                      </div>
                    </div>
                    <div>
                      <div className="inline-block px-4 py-1 bg-red/10 text-red text-sm font-medium rounded-full mb-4">
                        共同執筆
                      </div>
                      <h3 className="text-2xl font-bold text-gray-900 mb-4">
                        事業承継機関問題の研究
                      </h3>
                      <div className="space-y-3 text-gray-700">
                        <div className="flex items-start gap-3">
                          <div className="w-6 h-6 bg-red/10 rounded-full flex items-center justify-center flex-shrink-0 mt-0.5">
                            <i className="ri-building-line text-red text-sm"></i>
                          </div>
                          <div>
                            <div className="text-sm text-gray-500 mb-1">発行</div>
                            <div className="font-medium">日本公認会計士協会近畿会</div>
                          </div>
                        </div>
                        <div className="flex items-start gap-3">
                          <div className="w-6 h-6 bg-red/10 rounded-full flex items-center justify-center flex-shrink-0 mt-0.5">
                            <i className="ri-team-line text-red text-sm"></i>
                          </div>
                          <div>
                            <div className="text-sm text-gray-500 mb-1">執筆</div>
                            <div className="font-medium">事業承継委員会 共同執筆者</div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </motion.div>
            </div>
          </div>
        </section>

        {/* Lectures Section */}
        <section className="py-20 bg-white">
          <div className="max-w-7xl mx-auto px-6">
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              className="text-center mb-16"
            >
              <h2 className="text-4xl font-bold text-gray-900 mb-4">講演等</h2>
              <p className="text-gray-600">
                様々な場で専門知識を共有し、ビジネスの発展に貢献しています
              </p>
            </motion.div>

            <div className="grid md:grid-cols-3 gap-8">
              {/* 大阪弁護士会 */}
              <motion.div
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ delay: 0.1 }}
                className="bg-gradient-to-br from-red/5 to-red-light/5 rounded-3xl p-8 border border-red/10 hover:shadow-xl transition-all"
              >
                <div className="flex items-center gap-3 mb-6">
                  <div className="w-12 h-12 bg-red/10 rounded-full flex items-center justify-center flex-shrink-0">
                    <i className="ri-presentation-line text-red text-xl"></i>
                  </div>
                  <div>
                    <p className="text-sm text-gray-600 font-medium">2008年11月</p>
                  </div>
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-4">
                  大阪弁護士会<br />事業承継委員会セミナー
                </h3>
                <p className="text-gray-700 leading-relaxed mb-4">
                  パネリストとして登壇
                </p>
              </motion.div>

              {/* ランチェスター戦略学会 */}
              <motion.div
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ delay: 0.2 }}
                className="bg-gradient-to-br from-red/5 to-red-light/5 rounded-3xl p-8 border border-red/10 hover:shadow-xl transition-all"
              >
                <div className="flex items-center gap-3 mb-6">
                  <div className="w-12 h-12 bg-red/10 rounded-full flex items-center justify-center flex-shrink-0">
                    <i className="ri-presentation-line text-red text-xl"></i>
                  </div>
                  <div>
                    <p className="text-sm text-gray-600 font-medium">2013年12月8日</p>
                  </div>
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-4">
                  ランチェスター戦略学会
                </h3>
                <p className="text-gray-700 leading-relaxed mb-4">
                  テーマ「京都企業の戦略特性」
                </p>
                <p className="text-sm text-gray-600 leading-relaxed">
                  ランチェスター戦略は軍事理論を経営に応用したものであり、キャノン、ソニーなどが採用していたといわれる経営戦略です。
                </p>
              </motion.div>

              {/* 近畿税理士会 */}
              <motion.div
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ delay: 0.3 }}
                className="bg-gradient-to-br from-red/5 to-red-light/5 rounded-3xl p-8 border border-red/10 hover:shadow-xl transition-all"
              >
                <div className="flex items-center gap-3 mb-6">
                  <div className="w-12 h-12 bg-red/10 rounded-full flex items-center justify-center flex-shrink-0">
                    <i className="ri-presentation-line text-red text-xl"></i>
                  </div>
                  <div>
                    <p className="text-sm text-gray-600 font-medium">2013年12月11日</p>
                  </div>
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-4">
                  近畿税理士会下京支部研修
                </h3>
                <p className="text-gray-700 leading-relaxed mb-4">
                  税理士向け研修<br />
                  テーマ「非上場株式の売買時価ケース31」
                </p>
                <p className="text-sm text-gray-600 leading-relaxed">
                  非上場の株式の譲渡は税金の面で誰から誰に渡すかで大きな差が生じます。この部分は実務でも難しく、税理士の能力の差が表れやすい分野です。
                </p>
              </motion.div>
            </div>
          </div>
        </section>

        {/* Newspaper Section */}
        <section className="py-20 bg-white">
          <div className="max-w-5xl mx-auto px-6">
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              className="text-center mb-16"
            >
              <h2 className="text-4xl font-bold text-gray-900 mb-4">新聞掲載</h2>
              <p className="text-gray-600">
                有識者として招かれた活動が新聞に掲載されました
              </p>
            </motion.div>

            <motion.div
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
            >
              <div className="bg-gradient-to-br from-red/5 to-red-light/5 rounded-3xl p-8 border border-red/10">
                <div className="grid md:grid-cols-2 gap-8 items-center">
                  <div>
                    <div className="inline-block px-4 py-1 bg-red/10 text-red text-sm font-medium rounded-full mb-4">
                      北日本新聞掲載
                    </div>
                    <h3 className="text-2xl font-bold text-gray-900 mb-4">
                      黒部商工会議所 有識者として招聘
                    </h3>
                    <div className="space-y-4 text-gray-700">
                      <div className="flex items-start gap-3">
                        <div className="w-6 h-6 bg-red/10 rounded-full flex items-center justify-center flex-shrink-0 mt-0.5">
                          <i className="ri-calendar-line text-red text-sm"></i>
                        </div>
                        <div>
                          <div className="text-sm text-gray-500 mb-1">開催日</div>
                          <div className="font-medium">2014年8月1日</div>
                        </div>
                      </div>
                      <div className="flex items-start gap-3">
                        <div className="w-6 h-6 bg-red/10 rounded-full flex items-center justify-center flex-shrink-0 mt-0.5">
                          <i className="ri-map-pin-line text-red text-sm"></i>
                        </div>
                        <div>
                          <div className="text-sm text-gray-500 mb-1">場所</div>
                          <div className="font-medium">富山県 黒部商工会議所</div>
                        </div>
                      </div>
                      <div className="flex items-start gap-3">
                        <div className="w-6 h-6 bg-red/10 rounded-full flex items-center justify-center flex-shrink-0 mt-0.5">
                          <i className="ri-newspaper-line text-red text-sm"></i>
                        </div>
                        <div>
                          <div className="text-sm text-gray-500 mb-1">掲載</div>
                          <div className="font-medium">北日本新聞（平成26年8月2日）</div>
                        </div>
                      </div>
                      <p className="text-gray-600 leading-relaxed mt-6">
                        富山県の黒部商工会議所に有識者として招かれ、地域振興に関する講演を行いました。
                        その様子が北日本新聞に掲載され、地域経済の発展に貢献する活動として注目されました。
                      </p>
                    </div>
                  </div>
                  <div>
                    <div className="relative rounded-2xl overflow-hidden shadow-xl">
                      <img
                        src="https://static.readdy.ai/image/d7a11723d8aa082f15ef10141684e0c1/b7e2765fedd78a3635c87f3a2993183b.jpeg"
                        alt="北日本新聞掲載記事"
                        className="w-full h-auto object-cover"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </motion.div>
          </div>
        </section>

        {/* Other Activities Section */}
        <section className="py-20 bg-gradient-to-b from-gray-50 to-white">
          <div className="max-w-7xl mx-auto px-6">
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              className="text-center mb-16"
            >
              <h2 className="text-4xl font-bold text-gray-900 mb-4">その他の活動</h2>
              <p className="text-gray-600">
                幅広い分野での活動を通じて、ビジネスの発展に貢献しています
              </p>
            </motion.div>

            <div className="space-y-8">
              {/* 勝つ経営勉強会 */}
              <motion.div
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                className="bg-white rounded-3xl p-8 shadow-xl border border-gray-100"
              >
                <div className="flex items-start gap-6">
                  <div className="w-16 h-16 bg-red/10 rounded-2xl flex items-center justify-center flex-shrink-0">
                    <i className="ri-presentation-line text-red text-3xl"></i>
                  </div>
                  <div className="flex-1">
                    <h3 className="text-2xl font-bold text-gray-900 mb-4">
                      勝つ経営勉強会 主催
                    </h3>
                    <div className="space-y-3 text-gray-700">
                      <div className="flex items-center gap-3">
                        <div className="w-2 h-2 bg-red rounded-full"></div>
                        <p><strong className="text-red">2010年</strong> 計8回開催</p>
                      </div>
                      <div className="flex items-center gap-3">
                        <div className="w-2 h-2 bg-red rounded-full"></div>
                        <p><strong className="text-red">2011年</strong> 計11回開催</p>
                      </div>
                      <p className="mt-4 text-gray-600 leading-relaxed">
                        自主セミナーとして「勝つ経営勉強会」を主催し、経営者の方々に実践的な経営ノウハウを提供してきました。
                      </p>
                    </div>
                  </div>
                </div>
              </motion.div>

              {/* 外部講師活動 */}
              <motion.div
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ delay: 0.1 }}
                className="bg-white rounded-3xl p-8 shadow-xl border border-gray-100"
              >
                <div className="flex items-start gap-6">
                  <div className="w-16 h-16 bg-red/10 rounded-2xl flex items-center justify-center flex-shrink-0">
                    <i className="ri-book-open-line text-red text-3xl"></i>
                  </div>
                  <div className="flex-1">
                    <h3 className="text-2xl font-bold text-gray-900 mb-4">
                      外部講師活動
                    </h3>
                    <div className="space-y-3 text-gray-700">
                      <p className="mb-4">
                        お金の話、決算書、簿記、FP等について幅広く講義を実施
                      </p>
                      <div className="grid md:grid-cols-2 gap-4">
                        <div className="bg-red/5 rounded-xl p-4 border border-red/10">
                          <p className="text-sm text-gray-600 mb-2">2011年実績</p>
                          <p className="text-2xl font-bold text-gray-900">計36回</p>
                        </div>
                        <div className="bg-red/5 rounded-xl p-4 border border-red/10">
                          <p className="text-sm text-gray-600 mb-2">2012年・2013年</p>
                          <p className="text-2xl font-bold text-gray-900">計2回</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </motion.div>

              {/* 関西ビジネスサテライト新聞社 記者 */}
              <motion.div
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ delay: 0.2 }}
                className="bg-white rounded-3xl p-8 shadow-xl border border-gray-100"
              >
                <div className="flex items-start gap-6">
                  <div className="w-16 h-16 bg-red/10 rounded-2xl flex items-center justify-center flex-shrink-0">
                    <i className="ri-newspaper-line text-red text-3xl"></i>
                  </div>
                  <div className="flex-1">
                    <h3 className="text-2xl font-bold text-gray-900 mb-4">
                      関西ビジネスサテライト新聞社 記者
                    </h3>
                    <p className="text-gray-700 leading-relaxed">
                      上場準備会社（2013年12月に上場）から個人事業者まで、日本だけでなく海外まで幅広く取材を実施しました。
                    </p>
                  </div>
                </div>
              </motion.div>

              {/* 主要イベント協力実績 */}
              <motion.div
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ delay: 0.3 }}
                className="bg-white rounded-3xl p-8 shadow-xl border border-gray-100"
              >
                <div className="flex items-start gap-6">
                  <div className="w-16 h-16 bg-red/10 rounded-2xl flex items-center justify-center flex-shrink-0">
                    <i className="ri-calendar-event-line text-red text-3xl"></i>
                  </div>
                  <div className="flex-1">
                    <h3 className="text-2xl font-bold text-gray-900 mb-4">
                      主要イベント協力実績
                    </h3>
                    <div className="space-y-4">
                      <div className="bg-gradient-to-br from-red/5 to-red-light/5 rounded-2xl p-6 border border-red/10">
                        <div className="space-y-4">
                          <div className="border-l-4 border-red pl-4">
                            <p className="text-sm text-gray-600 mb-1">2011年5月10日・11日</p>
                            <p className="font-medium text-gray-900 mb-2">がんばろう関西マッチングフェア</p>
                            <p className="text-gray-700">来場者：計数可能分535名、推計1,000名</p>
                          </div>
                          <div className="border-l-4 border-red pl-4">
                            <p className="text-sm text-gray-600 mb-1">2011年10月26日</p>
                            <p className="font-medium text-gray-900 mb-2">健康癒しのフェスタ（第2回）</p>
                            <p className="text-gray-700">来場者：推計500名</p>
                          </div>
                          <div className="border-l-4 border-red pl-4">
                            <p className="text-sm text-gray-600 mb-1">2012年5月28日</p>
                            <p className="font-medium text-gray-900 mb-2">がんばろう関西マッチングフェア</p>
                            <p className="text-gray-700">来場者：計数可能分1,302名、推計1,500名</p>
                          </div>
                          <div className="border-l-4 border-red pl-4">
                            <p className="font-medium text-gray-900 mb-2">ビジネスプランプレゼンテーション</p>
                            <p className="text-gray-700 mb-2">来場者：約270名、出演者：8名</p>
                            <p className="text-red font-bold">成果：1名に対し1,000万円の出資が決定</p>
                          </div>
                        </div>
                      </div>

                      <div className="grid md:grid-cols-2 gap-4">
                        <div className="bg-red/5 rounded-xl p-4 border border-red/10">
                          <p className="text-sm text-gray-600 mb-2">サポーター制度設計</p>
                          <p className="text-gray-900 font-medium">年間継続収入</p>
                          <p className="text-2xl font-bold text-red">400万円</p>
                        </div>
                        <div className="bg-red/5 rounded-xl p-4 border border-red/10">
                          <p className="text-sm text-gray-600 mb-2">2010年</p>
                          <p className="text-gray-900 font-medium">京都初のビジネス朝活</p>
                          <p className="text-lg font-bold text-red">BNI「都チャプター」立ち上げ</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </motion.div>
            </div>
          </div>
        </section>

        {/* Affiliations Section */}
        <section className="py-20 bg-white">
          <div className="max-w-7xl mx-auto px-6">
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              className="text-center mb-16"
            >
              <h2 className="text-4xl font-bold text-gray-900 mb-4">所属団体</h2>
              <p className="text-gray-600">
                様々な専門団体に所属し、常に最新の知識と情報を取得しています
              </p>
            </motion.div>

            <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
              {[
                { name: '公認会計士協会京滋会', icon: 'ri-shield-check-line' },
                { name: '近畿税理士会下京支部', icon: 'ri-file-list-3-line' },
                { name: '国際税務研究会', icon: 'ri-global-line' },
                { name: '税務研究会', icon: 'ri-book-2-line' },
                { name: '盛和塾', icon: 'ri-team-line' },
                { name: '中小企業家同友会（京都、下京支部）', icon: 'ri-building-line' },
                { name: 'BNI新撰組チャプター', icon: 'ri-group-line' },
                { name: '日中技術青年交流協会', icon: 'ri-earth-line' }
              ].map((org, index) => (
                <motion.div
                  key={index}
                  initial={{ opacity: 0, y: 30 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true }}
                  transition={{ delay: index * 0.05 }}
                  className="bg-gradient-to-br from-red/5 to-red-light/5 rounded-2xl p-6 border border-red/10 hover:shadow-lg transition-all"
                >
                  <div className="flex flex-col items-center text-center gap-4">
                    <div className="w-14 h-14 bg-red/10 rounded-full flex items-center justify-center flex-shrink-0">
                      <i className={`${org.icon} text-red text-2xl`}></i>
                    </div>
                    <p className="text-gray-900 font-medium leading-snug">
                      {org.name}
                    </p>
                  </div>
                </motion.div>
              ))}
            </div>
          </div>
        </section>

        {/* CTA Section */}
        <section className="py-20 bg-gradient-to-br from-red-dark to-red">
          <div className="max-w-4xl mx-auto px-6 text-center">
            <motion.div
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
            >
              <h2 className="text-4xl font-bold text-white mb-6">
                あなたも「勝つ経営」を実現しませんか？
              </h2>
              <p className="text-white/90 mb-10 text-lg leading-relaxed">
                豊富な経験と専門知識で、あなたのビジネスの成長をサポートします。<br />
                まずは無料相談で、お気軽にご相談ください。
              </p>
              <motion.div
                initial={{ opacity: 0, y: 30 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: 0.6 }}
                className="text-center"
              >
                <a
                  href="https://docs.google.com/forms/d/e/1FAIpQLSfcI_iqOXmdZhJO8vkCvjObLY5GxPIAQ8kXxWKDFswsKGrSRQ/viewform?usp=publish-editor"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center gap-2 bg-red text-white px-8 py-4 rounded-full font-medium hover:bg-red/90 transition-colors whitespace-nowrap cursor-pointer shadow-xl"
                >
                  <span>お問い合わせ</span>
                  <i className="ri-arrow-right-line"></i>
                </a>
              </motion.div>
            </motion.div>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
};

export default ProfilePage;
